class SearchService {
    searchInstituciones(instituciones, query) {
        if (!query) return instituciones;
        
        const searchQuery = query.toLowerCase();
        return instituciones.filter(institucion => {
            const matchesInstitucion = institucion.nombre.toLowerCase().includes(searchQuery);
            const matchesTramites = institucion.tramites.some(tramite => 
                tramite.nombre.toLowerCase().includes(searchQuery)
            );
            return matchesInstitucion || matchesTramites;
        });
    }

    searchServices(instituciones, query, limit = 5) {
        if (!query) return { results: [], total: 0 };

        const searchQuery = query.toLowerCase();
        const allServices = [];
        
        instituciones.forEach(institucion => {
            institucion.tramites.forEach(tramite => {
                if (tramite.nombre.toLowerCase().includes(searchQuery)) {
                    allServices.push({
                        ...tramite,
                        institucion: institucion.nombre
                    });
                }
            });
        });

        return {
            results: allServices.slice(0, limit),
            total: allServices.length
        };
    }

    filterByService(instituciones, serviceName) {
        return instituciones.filter(institucion => 
            institucion.tramites.some(tramite => 
                tramite.nombre === serviceName
            )
        );
    }
}

export default new SearchService(); 